import React, { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function Newsletter() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're subscribed — welcome to the Journal.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-[#553204] text-[#F9EFE1]" data-testid="newsletter">
      <div className="max-w-4xl mx-auto px-6 py-16 lg:py-20 text-center">
        <p className="eyebrow text-[#D4AF37]">The Journal</p>
        <h2 className="font-display text-3xl sm:text-4xl font-medium mt-3 text-white">Travel notes, worth reading</h2>
        <p className="mt-3 text-[#F9EFE1]/75">Destination guides, inspiration and quiet stories from the road. No spam.</p>
        <form onSubmit={submit} className="mt-7 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input data-testid="newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email" className="flex-1 rounded-full bg-white/10 border border-white/20 px-5 py-3 text-sm text-white placeholder-white/50 outline-none focus:border-[#F49E1A]" />
          <button disabled={busy} data-testid="newsletter-submit" className="inline-flex items-center justify-center gap-2 rounded-full btn-orange px-6 py-3 text-sm disabled:opacity-60">
            <Send size={15} /> {busy ? "…" : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
}
